window.addEventListener("DOMContentLoaded", function () {
  const productEl = document.querySelector(".product-template-container");
  if (!productEl) return;
  function readProductJson() {
    const sectionId = productEl.dataset.sectionId;
    const dataEl = sectionId
      ? document.getElementById(`ProductJson-BottomBar-${sectionId}`)
      : null;
    if (!dataEl) return null;

    try {
      return JSON.parse(dataEl.textContent || "{}");
    } catch (error) {
      console.warn("Failed to parse product json for variant state", error);
      return null;
    }
  }

  const productData = readProductJson();

  function getVariantInput() {
    return productEl.querySelector("[data-product-form] input[name='id'], [data-product-form] select[name='id']");
  }

  function getVariantIdFromUrl() {
    return new URLSearchParams(window.location.search).get("variant");
  }

  function findVariantById(id) {
    if (!id || !productData || !Array.isArray(productData.variants)) return null;
    const normalizedId = String(id);
    return productData.variants.find((variant) => String(variant.id) === normalizedId) || null;
  }

  function syncVariantInputValue(id) {
    const input = getVariantInput();
    if (!input || !id) return;

    const idValue = String(id);
    if (input.tagName === "SELECT") {
      let optionExists = false;
      for (let i = 0; i < input.options.length; i++) {
        if (input.options[i].value === idValue) {
          optionExists = true;
          break;
        }
      }
      if (!optionExists) {
        const option = document.createElement("option");
        option.value = idValue;
        option.textContent = "Current Variant";
        input.appendChild(option);
      }
    }

    if (input.value !== idValue) {
      input.value = idValue;
    }
    input.setAttribute("value", idValue);
  }

  function createProductVariantState() {
    let currentVariantId = null;
    let currentVariant = null;

    function getCurrentVariantId() {
      const input = getVariantInput();
      if (input && input.value) return String(input.value);

      const urlVariant = getVariantIdFromUrl();
      if (urlVariant) return String(urlVariant);

      if (productEl.dataset.defaultVariantId) return String(productEl.dataset.defaultVariantId);
      return "";
    }

    function publish(source) {
      productEl.dispatchEvent(
        new CustomEvent("product:variant-state-change", {
          bubbles: true,
          detail: {
            variantId: currentVariantId,
            variant: currentVariant,
            productHandle: productEl.dataset.productHandle || "",
            source: source || "unknown",
          },
        })
      );
    }

    function setVariant(variantOrId, source) {
      const nextVariant = typeof variantOrId === "object" && variantOrId
        ? variantOrId
        : findVariantById(variantOrId);
      const nextVariantId = String(nextVariant?.id || variantOrId || "");
      if (!nextVariantId) return null;

      currentVariantId = nextVariantId;
      currentVariant = nextVariant || findVariantById(nextVariantId);
      syncVariantInputValue(nextVariantId);
      publish(source);
      return currentVariant;
    }

    function init() {
      setVariant(getCurrentVariantId(), "init");
    }

    return {
      init,
      setVariant,
      get id() {
        return currentVariantId || getCurrentVariantId();
      },
      get variant() {
        return currentVariant || findVariantById(currentVariantId || getCurrentVariantId());
      },
    };
  }

  const DOM = {
    productBundleEl: productEl?.querySelector("product-bundle-info"),
    totalPriceEl: productEl?.querySelector(".product-single__price"),
    compareTotalEl: productEl?.querySelector(
      ".product-single__price--compare-at"
    ),
    addCartEl: productEl?.querySelector(".custom_add_to_cart"),
    buyCartEl: productEl?.querySelector(".custom-buy-now-btn"),
    currentEl: null,
    currentType: "cart",
    // 价格状态
    originPrice: 0,
    originComparePrice: 0,
    currentAccessoryPrice: 0,
    currentAccessoryComparePrice: 0,
    bottomBar: document.querySelector(".common-tabbar-bottom-purchase-bar"),
    bottomBarColorEl: null,
    bottomBarPriceEl: null,
    bottomBarCompareEl: null,
    bottomBarDiscountEl: null,
    productDiscountEl: productEl?.querySelector(
      ".show-discount .discount-percent"
    ),
    bottomBarIdInput: null,
    bottomAddCartEl: document.querySelector(
      ".common-tabbar-bottom-purchase-bar .add-to-cart-btn-custom"
    ),
    bottomBuyNowEl: document.querySelector(
      ".common-tabbar-bottom-purchase-bar .buy-now-btn-custom"
    ),
  };

  const variantState = createProductVariantState();
  productEl.productVariantState = variantState;
  window.ProductVariantState = window.ProductVariantState || {};
  if (productEl.dataset.sectionId) {
    window.ProductVariantState[productEl.dataset.sectionId] = variantState;
  }

  // 底部栏事件
  function bindBottomBarCartEvent() {
    if (!DOM.bottomBar) return;

    if (DOM.bottomBar.dataset.bindCart === "1") return;
    DOM.bottomBar.dataset.bindCart = "1";

    DOM.bottomBar.addEventListener("click", (e) => {
      const btn = e.target.closest(
        ".common-tabbar-bottom-purchase-bar [data-action]"
      );
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const action = btn.dataset.action;
      if (action === "cart") {
        changeCurrentInfo(btn, "cart");
        bindQtyCartEvent();
      }

      if (action === "buy") {
        changeCurrentInfo(btn, "checkout");
        bindQtyCartEvent();
      }
    });
  }

  function initProductBasePrice() {
    if (!DOM.totalPriceEl) return;

    const salePrice = DOM.totalPriceEl.getAttribute("content") || "0";
    const comparePrice =
      DOM.compareTotalEl?.getAttribute("content") || salePrice;
    DOM.originPrice = salePrice * 100;
    DOM.originComparePrice = comparePrice * 100;
  }

  // 初始化底部栏元素引用
  function initBottomBarRefs() {
    const bar = DOM.bottomBar;
    console.group("🟢 initBottomBarRefs");
    console.groupEnd();
    if (!bar) return;

    bar.classList.add("show");

    DOM.bottomBarColorEl = bar.querySelector(".color-value");
    DOM.bottomBarPriceEl = bar.querySelector(".current-price");
    DOM.bottomBarCompareEl = bar.querySelector(".compare-price");
    DOM.bottomBarDiscountEl = bar.querySelector(".discount-badge");
    DOM.bottomBarIdInput = bar.querySelector('input[name="id"]');
  }

  // 更新底部栏价格显示
  function updateBottomBarDisplay(finalTotal, finalCompareTotal) {
    const bar = DOM.bottomBar;
    if (!bar || !DOM.bottomBarPriceEl) return;

    const formatMoney =
      window.theme?.Currency?.formatMoney ||
      ((price, format) => {
        const amount = (price / 100).toFixed(2);
        return format ? format.replace("{{ amount }}", amount) : `$${amount}`;
      });

    const formattedTotal = formatMoney(
      finalTotal,
      window.theme?.strings?.moneyFormat
    );
    DOM.bottomBarPriceEl.textContent = formattedTotal;

    // compare + discount
    if (finalCompareTotal > finalTotal) {
      if (DOM.bottomBarCompareEl) {
        DOM.bottomBarCompareEl.textContent = formatMoney(
          finalCompareTotal,
          window.theme?.strings?.moneyFormat
        );
        DOM.bottomBarCompareEl.style.display = "inline";
      }

      const dis = Math.round(
        ((finalCompareTotal - finalTotal) * 100) / finalCompareTotal
      );
      if (DOM.bottomBarDiscountEl) {
        DOM.bottomBarDiscountEl.textContent = `${dis}% OFF`;
        DOM.bottomBarDiscountEl.style.display = "inline-block";
        // DOM.productDiscountEl.textContent = `${dis}% OFF`;
      }
      if (DOM.productDiscountEl) {
        DOM.productDiscountEl.textContent = `${dis}%`;
      }
    } else {
      if (DOM.bottomBarCompareEl) DOM.bottomBarCompareEl.style.display = "none";
      if (DOM.bottomBarDiscountEl)
        DOM.bottomBarDiscountEl.style.display = "none";
    }
    DOM.bottomBarPriceEl.setAttribute('aria-label', 'Sale price: ' + formattedTotal + ' US dollars');
    DOM.bottomBarCompareEl.setAttribute('aria-label', 'Original price: ' + formatMoney(
      finalCompareTotal,
      window.theme?.strings?.moneyFormat
    ) + ' US dollars');
    // id 同步（用统一逻辑里的当前 base variant id）
    const id = DOM.addCartEl?.getAttribute("data-id");
    if (DOM.bottomBarIdInput && id) DOM.bottomBarIdInput.value = id;
  }

  // 更新底部栏变体
  function updateBottomBarColorByVariant(variant) {
    if (!DOM.bottomBarColorEl || !variant) return;
    const color = variant.options?.[0];
    DOM.bottomBarColorEl.textContent =
      color === "Default Title" ? "" : color || "";
  }

  // 监听配件价格变化事件
  function bindAccessoryPriceEvent() {
    document.addEventListener("accessory:priceChange", (e) => {
      console.group("🟡 accessory:priceChange");
      console.groupEnd();

      const { accessoryPrice = 0, accessoryComparePrice = 0 } = e.detail || {};
      DOM.currentAccessoryPrice = accessoryPrice;
      DOM.currentAccessoryComparePrice = accessoryComparePrice;
      updatePriceDisplay();
    });
  }

  // 更新价格显示
  function updatePriceDisplay() {
    console.group("💰 updatePriceDisplay");

    if (!DOM.totalPriceEl) return;

    const { total: finalTotal, compareTotal: finalCompareTotal } =
      calculateTotalPrice();

    // 格式化价格（使用主题内置方法或默认格式）
    const formatMoney =
      window.theme?.Currency?.formatMoney ||
      ((price, format) => {
        const amount = (price / 100).toFixed(2);
        return format ? format.replace("{{ amount }}", amount) : `$${amount}`;
      });

    const formattedTotal = formatMoney(
      finalTotal,
      window.theme?.strings?.moneyFormat
    );
    const formattedCompare = formatMoney(
      finalCompareTotal,
      window.theme?.strings?.moneyFormat
    );

    // 更新售价
    DOM.totalPriceEl.textContent = formattedTotal;
    if (finalTotal) {
      DOM.totalPriceEl.setAttribute('content', finalTotal / 100)
    }

    if (finalCompareTotal > finalTotal) {
      if (DOM.compareTotalEl) {
        DOM.compareTotalEl.textContent = formattedCompare;
      } else {
        const compareEl = document.createElement("span");
        compareEl.className = "product-single__price--compare-at";
        compareEl.textContent = formattedCompare;
        DOM.totalPriceEl.after(compareEl);
        DOM.compareTotalEl = compareEl;
      }
    } else if (DOM.compareTotalEl) {
      DOM.compareTotalEl.remove();
      DOM.compareTotalEl = null;
    }
    console.groupEnd();

    updateBottomBarDisplay(finalTotal, finalCompareTotal);
  }

  // 处理捆绑产品价格变化
  function handleBundleInfoChange(e) {
    console.group("🟡 bundle:InfoChange");
    console.groupEnd();

    const {
      itemPrice = 0,
      comparePrice = 0,
      id = null,
      color = "",
      bundleIds = [],
    } = e.detail || {};
    DOM.originPrice = itemPrice;
    DOM.originComparePrice = comparePrice;
    changeCartAndBuyId(id, bundleIds);
    if (DOM.bottomBarColorEl) {
      DOM.bottomBarColorEl.textContent = color;
    }

    updatePriceDisplay();
  }

  // 绑定捆绑产品价格事件
  function bindBundlePriceEvent() {
    if (!DOM.productBundleEl) return;

    // 先移除旧事件避免重复绑定
    DOM.productBundleEl.removeEventListener(
      "bundle:InfoChange",
      handleBundleInfoChange
    );
    DOM.productBundleEl.addEventListener(
      "bundle:InfoChange",
      handleBundleInfoChange
    );
  }

  // 计算总价
  function calculateTotalPrice() {
    console.group("🔢 calculateTotalPrice");
    const result = {
      total: DOM.originPrice + DOM.currentAccessoryPrice,
      compareTotal: DOM.originComparePrice + DOM.currentAccessoryComparePrice,
    };
    console.groupEnd();
    return result;

    return {
      total: DOM.originPrice + DOM.currentAccessoryPrice,
      compareTotal: DOM.originComparePrice + DOM.currentAccessoryComparePrice,
    };
  }

  //更新无库存状态
  function updateVariantAvailable(available) {
    const buyNowButton = DOM.buyCartEl
    if (buyNowButton) {
      available ? buyNowButton.classList.remove('custom-buy-now-btn-sold-out') : buyNowButton.classList.add('custom-buy-now-btn-sold-out')
    }
  }

  // 监听主题变体价格变化
  function bindVariantPriceChangeFromTheme() {
    document.addEventListener("variant:change", (ev) => {
      console.group("🟡 variant:change");
      console.groupEnd();

      const { variant } = ev.detail || {};
      if (!variant) return;
      if (variantState) variantState.setVariant(variant, "theme:variant:change");
      // 更新加入购物车按钮的变体ID
      changeCartAndBuyId(variant.id, []);

      const price = variant.price;
      const compare = variant.compare_at_price;

      DOM.originPrice = price;
      DOM.originComparePrice = compare;
      updatePriceDisplay();
      updateBottomBarColorByVariant(variant);
      updateVariantAvailable(variant.available)
    });
  }

  // 更新购物车按钮的变体ID
  function changeCartAndBuyId(id, bundleIds = []) {
    if (!id) return;
    const normalizedBundleIds = Array.isArray(bundleIds)
      ? bundleIds.filter(Boolean).map(String)
      : String(bundleIds || "")
        .split(",")
        .map((bundleId) => bundleId.trim())
        .filter(Boolean);
    const bundleIdsValue = normalizedBundleIds.join(",");
    const syncCartButton = (button) => {
      if (!button) return;
      button.setAttribute("data-id", id);
      if (bundleIdsValue) {
        button.setAttribute("data-bundle-ids", bundleIdsValue);
      } else {
        button.removeAttribute("data-bundle-ids");
      }
    };

    syncCartButton(DOM.addCartEl);
    syncCartButton(DOM.buyCartEl);
    syncCartButton(DOM.bottomAddCartEl);
    syncCartButton(DOM.bottomBuyNowEl);
    
    // Update the main form's variant selector so UpCart/theme scripts serialize the correct ID
    syncVariantInputValue(id);
    const selectEl = productEl?.querySelector("select[name='id']");
    if (selectEl) {
      // If the ID is from a different bundle product, it won't exist in the select yet.
      // We must append it as an option so the select element accepts the value assignment.
      let optionExists = false;
      for (let i = 0; i < selectEl.options.length; i++) {
        if (selectEl.options[i].value == id) {
          optionExists = true;
          break;
        }
      }
      if (!optionExists) {
        const newOption = document.createElement("option");
        newOption.value = id;
        newOption.textContent = "Bundle Option";
        selectEl.appendChild(newOption);
      }
      selectEl.value = id;
    }
  }

  // 加入购物车逻辑
  async function addOneToCart(variants) {
    if (!DOM.currentEl) return;

    const itemMap = new Map();
    variants.forEach(({ id, quantity }) => {
      const variantId = String(id || "").trim();
      const qty = parseInt(quantity, 10) || 0;
      if (!variantId || qty <= 0) return;
      itemMap.set(variantId, (itemMap.get(variantId) || 0) + qty);
    });

    const items = Array.from(itemMap, ([id, quantity]) => ({ id, quantity }));
    if (!items.length) return;

    // 显示加载状态
    DOM.currentEl.classList.add("loading");

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        throw new Error(`添加产品失败: ${response.statusText}`);
      }

      await response.json();
      const cartRes = await fetch("/cart.js");
      const cart = await cartRes.json();
      if (
        cart &&
        window.CartApi &&
        typeof window.CartApi.notifyTimberCartUpdated === 'function'
      ) {
        try {
          await window.CartApi.notifyTimberCartUpdated(cart, {
            source: 'section_product_template_add',
          });
        } catch (e) {
          console.error('处理购物车赠品时出错:', e);
        }
      }
      const type = DOM.currentType;
      if (type === "checkout") {
        window.location.href = "/checkout";
      } else {
        // 触发购物车抽屉
        const cartDrawerBtn = document.querySelector(
          ".js-drawer-open-button-right"
        );
        if (cartDrawerBtn) cartDrawerBtn.click();
      }
    } catch (error) {
      console.error("添加到购物车失败:", error);
      alert(`添加产品失败: ${error.message}`);
    } finally {
      // 无论成功失败都移除加载状态
      DOM.currentEl.classList.remove("loading");
    }
  }

  // 绑定加入购物车按钮事件
  function bindCartEvent() {
    if (!DOM.addCartEl && !DOM.buyCartEl) return;
    if (DOM.addCartEl) {
      DOM.addCartEl.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        changeCurrentInfo(DOM.addCartEl, "cart");
        bindQtyCartEvent();
      }, true); // Use capture phase to intercept before UpCart
    }

    if (DOM.buyCartEl) {
      DOM.buyCartEl.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        changeCurrentInfo(DOM.buyCartEl, "checkout");
        bindQtyCartEvent();
      }, true);
    }
  }
  function changeCurrentInfo(el, type) {
    DOM.currentEl = el;
    DOM.currentType = type;
  }
  function bindQtyCartEvent() {
    console.group("🛒 bindQtyCartEvent");

    const qtyInput = productEl?.querySelector(
      "[data-product-form] .product-single__quantity .js-qty__num"
    );
    const productQty = qtyInput
      ? Math.max(1, parseInt(qtyInput.value) || 1)
      : 1;

    const sourceEl = DOM.currentEl || DOM.addCartEl;
    const bundleIds = (
      sourceEl?.getAttribute("data-bundle-ids") ||
      DOM.addCartEl?.getAttribute("data-bundle-ids") ||
      ""
    )
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    const baseId = sourceEl?.getAttribute("data-id") || DOM.addCartEl?.getAttribute("data-id") || variantState?.id;
    const baseItems = bundleIds.length
      ? bundleIds.map((id) => ({
        id,
        quantity: productQty,
      }))
      : [{
        id: baseId,
        quantity: productQty,
      }];

    const accessoryItems = [];
    document
      .querySelectorAll(".header-case-content .js-case-qty__num")
      .forEach((input) => {
        const qty = Math.max(0, parseInt(input.value) || 0);
        if (qty > 0) {
          accessoryItems.push({
            id: input.dataset.id,
            product_id: input.dataset.productId,
            quantity: qty,
          });
        }
      });

    const allItems = [...baseItems, ...accessoryItems];
    if (allItems.length > 0) {
      console.groupEnd();

      addOneToCart(allItems);
    }
  }

  // 初始化所有功能
  function init() {
    console.group("🟢 INIT()");
    console.groupEnd();

    initBottomBarRefs(); // 先拿到底部条节点
    variantState.init();
    initProductBasePrice(); // 初始化 origin
    bindBundlePriceEvent();
    bindAccessoryPriceEvent();
    bindVariantPriceChangeFromTheme();
    bindCartEvent();
    bindBottomBarCartEvent();
    updatePriceDisplay(); // 主价/底部价首屏同步一次
  }

  init();
});
